import http from "helpers/http.js";

const API_URL = process.env.REACT_APP_API_URL;


const logError = async (message, error) => {
    var configLogError = {
        method: 'post',
        url: API_URL + 'api/logging/log-error',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            message,
            error
        }
    };

    return http(configLogError)
        .then(function (response) {
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return error;
        });
};

const logDeviceCapabilities = async (report) => {
    const requestConf = {
        method: "post",
        url: API_URL + "api/telemetry/device-capabilities",
        headers: { "Content-Type": "application/json" },
        data: report,
    };

    try {
        const response = await http(requestConf);
        console.log(response)
        return response.data;
    } catch (error) {
        console.error("logDeviceCapabilities failed, req:", requestConf);
        return error;
    }
};

export default {
    logError,
    logDeviceCapabilities
};
